<div fxFlexFill fxLayout="column">
  <ng-container *ngIf="stepActive === 1">
    <mat-tab-group fxFlexFill mat-stretch-tabs [selectedIndex]="tabSelectedIndex"
      (selectedTabChange)="onTabChange($event)">
      <mat-tab label="{{ 'call_transfer.to_operator' | translate }}">
        <div class="content-wrapper">
          <div class="filter-container" fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex>
              <mat-slide-toggle (change)="onChangeGroupBy($event)">
                {{ 'call_transfer.dialogs.grouped_by_tag' | translate }}
              </mat-slide-toggle>
            </div>
            <div fxFlex="10"></div>
            <div fxFlex>
              <flex-search-input [(ngModel)]="filter_value" placeholder="{{ 'public.search' | translate }}"
                ngClass.xs="full-width"></flex-search-input>
            </div>
          </div>

          <div class="overview-scroll">
            <div class="wrapper">
              <ng-container *ngIf="!groupByTag;else GroupedByTag">
                <h3>{{ 'call_transfer.dialogs.transfer.agents_available' | translate }}</h3>
                <div fxLayout="row wrap" fxLayout.xs="column" class="agent-list">
                  <ng-container *ngFor="let agentAvailable of filtered_available_agents">
                    <div fxFlex.xs="auto" fxFlex="0 1 calc(33.3% - 10px)" class="agent-wrapper">
                      <div class="bg-gray" (click)="selectAgent(agentAvailable)"
                        [ngClass]="{'selected': selectedAgent && agentAvailable.id === selectedAgent.id}">
                        <agent-item [avatar]="true" [agent]="agentAvailable" [displayCallInfo]="false">
                        </agent-item>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <h3>{{ 'call_transfer.dialogs.transfer.agents_busy' | translate }}</h3>
                <div fxLayout="row wrap" fxLayout.xs="column" class="agent-list">
                  <ng-container *ngFor="let agentBusy of filtered_busy_agents">
                    <div fxFlex.xs="auto" fxFlex="0 1 calc(33.3% - 10px)" class="agent-wrapper">
                      <div class="bg-gray" (click)="selectAgent(agentBusy)"
                        [ngClass]="{'selected': selectedAgent && agentBusy.id === selectedAgent.id}">
                        <agent-item [avatar]="true" [agent]="agentBusy" [displayCallInfo]="false">
                        </agent-item>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-template #GroupedByTag>
                <div *ngFor="let tag of filtered_available_tags">
                  <h3 *ngIf="tag.tag_name">{{ tag.tag_name }}</h3>
                  <div fxLayout="row wrap" fxLayout.xs="column" class="agent-list">
                    <ng-container *ngFor="let agent of get_agents_by_tagId(tag.id)">
                      <div fxFlex.xs="auto" fxFlex="0 1 calc(33.3% - 10px)" class="agent-wrapper">
                        <div class="bg-gray" (click)="selectAgent(agent)"
                          [ngClass]="{'selected': selectedAgent && agent.id === selectedAgent.id}">
                          <agent-item [avatar]="true" [agent]="agent" [displayCallInfo]="false">
                          </agent-item>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngIf="get_others_tag_agents.length">
                  <div>
                    <h3>{{'tag.other_agents'|translate}}</h3>
                    <div fxLayout="row wrap" fxLayout.xs="column" class="agent-list">
                      <ng-container *ngFor="let agent of get_others_tag_agents">
                        <div fxFlex.xs="auto" fxFlex="0 1 calc(33.3% - 10px)" class="agent-wrapper">
                          <div class="bg-gray" (click)="selectAgent(agent)"
                            [ngClass]="{'selected': selectedAgent && agent.id === selectedAgent.id}">
                            <agent-item [avatar]="true" [agent]="agent" [displayCallInfo]="false">
                            </agent-item>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'call_transfer.to_number' | translate }}">
        <div class="content-row ma-1">
          <div class="phone-number-input">
            <mat-form-field class="full-width">
              <mat-label>{{ 'call_transfer.to_other_number' | translate }}</mat-label>
              <input matInput type="tel" [(ngModel)]="other_number" (ngModelChange)="other_number_error = !other_number"
                placeholder="{{ 'call_transfer.phone_number' | translate }}">
              <button mat-button *ngIf="other_number" matSuffix mat-icon-button attr.aria-label="Clear"
                (click)="other_number = undefined">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <span class="mat-text-warn" *ngIf="other_number_error">{{ 'form.validator.field_required'|translate
              }}</span>
          </div>
          <button mat-stroked-button color="accent" (click)="selectOtherNumber()" *ngIf="isDialogTransferCall()">{{
            'public.apply'|translate }}</button>
        </div>
        <ng-container *ngIf="isTranferNumber">
          <!-- <h3>{{ 'call_transfer.dialogs.transfer.to_predefined_number' | translate }}</h3> -->
          <div class="filter-container mx-1 mb-1">
            <flex-search-input [(ngModel)]="filter_value" placeholder="{{ 'public.search' | translate }}"
              class="full-width"></flex-search-input>
          </div>
          <div class="list-wrapper transfer-number-container">
            <mat-divider></mat-divider>
            <mat-nav-list>
              <mat-list-item *ngFor="let tn of transfer_numbers"
                [ngClass]="{'selected': selectedTransferNumber && tn.phone_number === selectedTransferNumber.phone_number}"
                (click)="selectNumber(tn)">
                <div matLine class="transfer-label">{{ tn.label }}</div>
                <mat-divider matLine></mat-divider>
                <div class="transfer-number">{{ tn.phone_number }}</div>
              </mat-list-item>
            </mat-nav-list>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab label="{{ 'call_transfer.to_application' | translate }}" *ngIf="devMode && transferApps.length !== 0">
        <div class="filter-container ma-1">
          <flex-search-input [(ngModel)]="filter_value" placeholder="{{ 'public.search' | translate }}"
            class="full-width"></flex-search-input>
        </div>
        <div class="list-wrapper transfer-app-container">
          <mat-divider></mat-divider>
          <mat-nav-list>
            <mat-list-item *ngFor="let app of filtered_transfer_apps"
              [ngClass]="{'selected': selectedTransferApp && app === selectedTransferApp}" (click)="selectApp(app)">
              <div matLine class="transfer-label">{{ app.label }}</div>
              <mat-divider matLine></mat-divider>
            </mat-list-item>
          </mat-nav-list>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <div class="content-wrapper pa-1" *ngIf="stepActive === 2">
    <ng-container *ngIf="isDialogTransferCall() && result.destination_type === TransferDestinationType.USER">
      <mat-form-field class="full-width">
        <mat-label>{{ 'call_transfer.transfer_reason' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="result.transfer_reason"
          placeholder="{{ 'call_transfer.transfer_reason' | translate }} {{result.destination.name}}"></textarea>
      </mat-form-field>
    </ng-container>
    <ng-container
      *ngIf="isDialogTransferCall() && result.destination_type === TransferDestinationType.NUMBER || result.destination_type === TransferDestinationType.APPLICATION">
      <div fxLayout="column" fxLayoutAlign="center center">
        <div fxFlex>
          <div>{{ 'call_transfer.dialogs.transfer.message_transfer_to' | translate }}</div>
        </div>
        <div>
          <h2 class="mat-text-warn">
            {{result.destination_type === TransferDestinationType.NUMBER ? result.destination
            :result.destination.label}}
          </h2>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="dialogType === 'add_participant'">
      <div *ngIf="result.destination_type === TransferDestinationType.USER"
        [innerHTML]="'call_transfer.dialogs.message_add_participant'|translate: {value: result.destination.name}">
      </div>
      <div
        *ngIf="result.destination_type === TransferDestinationType.NUMBER || result.destination_type === TransferDestinationType.APPLICATION"
        [innerHTML]="'call_transfer.dialogs.message_add_participant'|translate: {value: result.destination_type ===
          TransferDestinationType.NUMBER ? result.destination :result.destination.label}">
      </div>
    </ng-container>
  </div>
</div>
